import styled from 'styled-components';

interface IStyledButtonWithLoadingProps {
  marginTopPx?: number;
}

export const StyledAddNewCardContainer = styled.div`
  margin-top: 28px;
`;

export const StyledButtonWithLoading = styled.button<IStyledButtonWithLoadingProps>`
  margin-top: ${(props) => (props.marginTopPx ? `${props.marginTopPx}px` : '0px')};

  padding: 7px;

  border-radius: 4px;
  width: 100%;
  height: 40px;
  background-color: #177590;

  span {
    color: white;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
  }

  svg {
    color: white;
    margin-left: auto;
    margin-right: auto;
    height: 24px;
    width: 24px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const StyledCardInputPlaceholder = styled.div`
  margin: 24px 0 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #5b5b5b;
`;

export const CardElementWrapper = styled.div`
  height: 40px;
  border: 1px solid #afafaf;
  border-radius: 3px;
  padding: 12px;
  margin-bottom: 24px;
`;
